import { CheckboxInput } from "@fidget/common/components/form/checkboxInput";
import { intl } from "@fidget/common/i18n";
import React, { useEffect, useState } from "react";
import { DiscardApplyButtons } from "../../../discardApplyButtons";
import styles from "./ActivateTransferCheckbox.css";

interface Props {
  value: boolean;
  onSave: (newState: boolean) => void;
}

export const ActivateTransferCheckbox = ({ value, onSave }: Props) => {
  const [newValue, setNewValue] = useState(value);

  useEffect(() => {
    setNewValue(value);
  }, [value]);

  const handleApply = () => {
    onSave(newValue);
  };

  return (
    <div className={styles.container}>
      <CheckboxInput
        id="settings.assignmentRules.manualAssignment.activateCheckbox"
        onChange={() => setNewValue(!newValue)}
        value={newValue}
        label={intl.formatMessage(
          "settings.assignmentRules.manualAssignment.activateCheckbox.label"
        )}
      />
      <DiscardApplyButtons
        onDiscard={() => setNewValue(value)}
        hidden={newValue === value}
        onApply={handleApply}
        alignToLeft
      />
    </div>
  );
};
